module.exports = __webpack_public_path__ + "img/gjxx.9e0477d0.png";